import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { QuizQuestionFacade } from '../facades/quiz-question.facade';

export function quizQuestionCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const quizQuestionFacade = inject(QuizQuestionFacade);
        quizQuestionFacade.clear();

        return true;
    };
}
